import { createAsyncThunk } from '@reduxjs/toolkit';
import { authService } from '../../services/auth.service';

export interface AuthRequest {
  code: string;
  state: string;
  local?: boolean;
}

export const auth = {
  login: createAsyncThunk('auth/login', async (_, { rejectWithValue }) => {
    try {
      const response = await authService.login();
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Login failed');
    }
  }),

  token: createAsyncThunk('auth/token', async (params: AuthRequest, { rejectWithValue }) => {
    try {
      const response = await authService.auth(params);
      // Store token to local storage
      // Writing storage here so it will be usefull in slice.ts to set up state based on token
      localStorage.setItem('token', response.access_token);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Token exchange failed');
    }
  }),

  logout: createAsyncThunk('auth/logout', async (_, { rejectWithValue }) => {
    try {
      const response = await authService.logout();
      // Clear token from local storage
      localStorage.removeItem('token');
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Logout failed');
    }
  }),
};
